const MuiInputLabel = (theme) => ({
  formControl: {
    "&$focused": {
      color: theme.palette.primary.main,
    },
  },
});

export default MuiInputLabel;
